module.exports = __webpack_public_path__ + "static/media/css.d3ad67fa.svg";